export default __webpack_public_path__ + "static/media/thum3.f4574367.jpg";